import * as swcHelpers from '@swc/helpers';
import { getUrl } from './get-url.js';

function createMenu({ menu  } = {}, page) {
    if (!menu || !menu.siteMenuItems.length) {
        return [];
    }
    return mapToMenu(menu.siteMenuItems, page);
}
function mapToMenu(items, page) {
    return items.map((item)=>{
        const link = item._links.site;
        var ref;
        const menuItem = {
            label: item.name,
            link: swcHelpers.objectSpread({}, link, {
                href: (ref = parseHref(link, page)) !== null && ref !== void 0 ? ref : '',
                type: (link === null || link === void 0 ? void 0 : link.type) === 'internal' ? 'internal' : 'external'
            })
        };
        if (item.parameters && Object.keys(item.parameters).length > 0) {
            menuItem.parameters = item.parameters;
        }
        if (item.childMenuItems && item.childMenuItems.length > 0) {
            menuItem.childMenuItems = mapToMenu(item.childMenuItems, page);
        }
        return menuItem;
    });
}
function parseHref(link, page) {
    if (link && page) {
        return getUrl(link.href, page);
    }
}

export { createMenu, mapToMenu, parseHref };
//# sourceMappingURL=create-menu.js.map
